
























import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'ChemUott1721M6_Task26',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data(): any {
    return {
      inputs: {
        studentAnswer: null,
      },
      options: [
        {
          image: prefixPublicAsset('/img/assignments/uOttawaTask26_optionA.png'),
          value: 'oxidationTwo',
        },
        {
          image: prefixPublicAsset('/img/assignments/uOttawaTask26_optionB.png'),
          value: 'oxidationOne',
        },
        {image: prefixPublicAsset('/img/assignments/uOttawaTask26_optionC.png'), value: 'c'},
        {
          image: prefixPublicAsset('/img/assignments/uOttawaTask26_optionD.png'),
          value: 'oxidationNitrogen',
        },
      ],
    };
  },
};
